import { HardwareFieldDefinition, FieldGrouping, HardwareFieldDefinitionListResponse } from '../services/typesService';
const T0 = '2026-09-28T00:00:00Z';

export const CONFIG_GROUPS: FieldGrouping[] = [
  { id: 1, code: 'mqtt', name: 'MQTT', display_order: 1, is_system: true, created_at: T0, updated_at: T0 },
  { id: 2, code: 'syslog', name: 'Syslog', display_order: 2, is_system: true, created_at: T0, updated_at: T0 },
  { id: 3, code: 'general', name: 'General', display_order: 3, is_system: true, created_at: T0, updated_at: T0 },
];

const group = (code: 'mqtt' | 'syslog' | 'general') => CONFIG_GROUPS.find((g) => g.code === code)!;

const field = (
  id: number,
  name: string,
  label: string,
  type: HardwareFieldDefinition['value_type'],
  grp: 'mqtt' | 'syslog' | 'general',
  order: number,
  extra: Partial<HardwareFieldDefinition> = {},
): HardwareFieldDefinition => ({
  id,
  hardware_type_id: 0,
  grouping_id: group(grp).id,
  grouping_code: group(grp).code,
  grouping_name: group(grp).name,
  field_name: name,
  display_name: label,
  value_type: type,
  is_required: false,
  display_order: order,
  is_system: true,
  expose_on_wire: true,
  created_at: T0,
  updated_at: T0,
  ...extra,
});

export const CONFIG_FIELDS: HardwareFieldDefinition[] = [
  field(1, 'mqtt_host', 'MQTT host', 'hostname', 'mqtt', 1, { placeholder: 'broker.example.com' }),
  field(2, 'mqtt_port', 'MQTT port', 'port', 'mqtt', 2, { min_value: 1, max_value: 65535, placeholder: '1883' }),
  field(3, 'mqtt_user', 'MQTT user', 'string', 'mqtt', 3),
  field(4, 'mqtt_pass', 'MQTT password', 'password', 'mqtt', 4),
  field(5, 'syslog_host', 'Syslog host', 'hostname', 'syslog', 1),
  field(6, 'syslog_port', 'Syslog port', 'port', 'syslog', 2, { min_value: 1, max_value: 65535, placeholder: '514' }),
  field(7, 'syslog_facility', 'Syslog facility', 'string', 'syslog', 3, { placeholder: '7' }),
  field(8, 'provisioning', 'Provisioning server', 'url', 'general', 1, { placeholder: 'https://provisioning.example.com' }),
  field(9, 'keepalive_timer', 'Keepalive (s)', 'number', 'general', 2, { min_value: 1, placeholder: '60' }),
  field(10, 'password', 'Device password', 'password', 'general', 3),
];

export const CONFIG_FIELD_NAMES: string[] = CONFIG_FIELDS.map((f) => f.field_name);

/**
 * The gateway types that read the fixed keys above (MQTT, syslog, general)
 * from their configuration. Any other type (PGA, IOTL, …) only receives the
 * additional configuration (jsonAdditionalConfig), so the Settings tab shows
 * it that section alone.
 */
export const FIXED_CONFIG_TYPES: string[] = ['P4GU', 'TMS2'];

export const usesFixedConfig = (deviceType: string | null | undefined): boolean =>
  FIXED_CONFIG_TYPES.includes((deviceType ?? '').toUpperCase());

/** The list in the envelope the old field-definition endpoint returned. */
export const configFieldsResponse = (hardwareTypeId: number, hardwareTypeCode: string): HardwareFieldDefinitionListResponse => ({
  items: CONFIG_FIELDS.map((f) => ({ ...f, hardware_type_id: hardwareTypeId })),
  total: CONFIG_FIELDS.length,
  hardware_type_id: hardwareTypeId,
  hardware_type_code: hardwareTypeCode,
});
